export function createScript(source, preconnect) {
    return new Promise(function (resolve, reject) {
        var head = document.head || document.getElementsByTagName("head")[0];
        var script = document.createElement("script");
        script.async = true;
        script.src = source;
        script.charset = "utf-8";
    
        if (preconnect) {
            var link = document.createElement("link");
            link.href = preconnect;
            link.rel = "preconnect";
            head.appendChild(link);
        }
    
        head.appendChild(script);
        script.onload = resolve;
        script.onerror = reject;
    });
}